import { Select, SelectItem } from '@nextui-org/react';

interface CostFilterTypeProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
  label?: string;
}

const CostFilterType = ({
  value,
  onChange,
  className = 'min-w-32',
  disabled = false,
  label = 'Filtro de Costos',
}: CostFilterTypeProps) => {
  const options = [
    {
      key: 'all',
      label: 'Todos',
      description: 'Incluye liquidaciones aunque falten algunos costos',
    },
    {
      key: 'complete_only',
      label: 'Solo Costos Completos',
      description:
        'Solo liquidaciones con comisión, impuestos, flete y otros costos > 0',
    },
  ];

  return (
    <Select
      label={label}
      selectedKeys={[value]}
      onChange={(e) => onChange(e.target.value)}
      className={className}
      isDisabled={disabled}
      aria-label='Selecciona el tipo de filtro de costos'
    >
      {options.map((option) => (
        <SelectItem
          key={option.key}
          value={option.key}
          description={option.description}
        >
          {option.label}
        </SelectItem>
      ))}
    </Select>
  );
};

export default CostFilterType;
